<div class="selectCodCountry position-relative w-100" (clickOutside)="hideSelect()">
    <button
        class="button-select form-control w-100 d-flex align-items-center"
        [value]="valueCode ?? defaultCountry.alpha2Code"
        (click)="toggleClass()"
        type="button"
        [disabled]="disabled"
    >
        <ng-container *ngIf="countryName">
            <img
                src="{{ assetsUrl }}{{ mfsPath }}/img/front/countryFlags/{{ srcImg }}"
                class="width-img-flag rounded"
            />
            <span class="ml-2">{{ countryName }}</span>
        </ng-container>
        <ng-container *ngIf="!countryName && defaultCountry">
            <img
                src="{{ assetsUrl }}{{ mfsPath }}/img/front/countryFlags/{{ getFlag(defaultCountry) }}"
                class="width-img-flag rounded"
            />
            <span class="ml-2">{{ countryName ?? defaultCountry[nameKey] }}</span>
        </ng-container>
    </button>
    <div class="container-select position-absolute w-100 rounded bg-white d-none" [id]="idSelect">
        <ul class="ul-select select-scrollbar my-2 mx-0 p-0">
            <li *ngFor="let country of countries" class="d-flex align-items-center p-2" (click)="selectOption(country)">
                <img
                    src="{{ assetsUrl }}{{ mfsPath }}/img/front/countryFlags/{{ getFlag(country) }} "
                    value="{{ country.alpha2Code }} "
                    class="width-img-flag rounded"
                />
                <span class="ml-2">{{ country[nameKey] }}</span>
            </li>
        </ul>
    </div>
</div>
